// `isTestSetup` opens the Test window's setup stage (no run yet), which shows the workflow's stored test; opening
// never carries choices of its own (2026-10-02: the stored test is the only one). Opening a run clears it.
const setAutomationWorkflowRunLogsModal = ({ open = false, workflowId = null, workflowRunId = null, isTestSetup = false, searchMatch = null, fullServiceProjectId = null } = {}) => {
  return {
    type: 'uiSetAutomationWorkflowRunLogsModal',
    payload: {
      open: open === true,
      workflowId: workflowId ? String(workflowId).trim() : null,
      workflowRunId: workflowRunId ? String(workflowRunId).trim() : null,
      isTestSetup: isTestSetup === true,
      searchMatch,
      fullServiceProjectId
    }
  };
};

export default setAutomationWorkflowRunLogsModal;
